export default "<div class=\"card\">\n  <span class=\"title1\">{{title}}</span>\n  <br>\n  <span class=\"title2\">{{subtitle}}</span>\n</div>\n"